import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../helpers/api';
import { tableConfig } from '../../../settings/index';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';

const api = new Api('dashboard/leaderboards');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter, ...payload } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const {
        records: data,
        filters,
        totalCount: total,
        filteredCount: filteredTotal,
        sortableColumns,
      } = result.data.success.data;

      yield put(actions.loadDataSuccess({ data, total, filteredTotal, filters, sortableColumns }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
